import { Bill } from '@features/bills/types/bill'
import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'
import { IntegrationStatusRejectCode } from '@features/cegidIntegration/enums/IntegrationStatusRejectCode'

import { getLatestIntegrationStatus } from './getLatestIntegrationStatus'

export const BillIntegrationStatusRetryable = new Set<IntegrationStatusRejectCode>([
  IntegrationStatusRejectCode.Other,
  IntegrationStatusRejectCode.FailedToDownload,
])

export const isBillSyncRetryable = ({
  integrationStatus,
}: {
  bill?: Bill | null
  integrationStatus?: IntegrationStatus[]
}) => {
  const latestIntegrationStatus = getLatestIntegrationStatus(integrationStatus)

  if (!latestIntegrationStatus) {
    return true
  }

  const { rejectCode, status } = latestIntegrationStatus

  if (status === CegidIntegrationStatus.Failed && rejectCode) {
    return BillIntegrationStatusRetryable.has(rejectCode)
  }

  return false
}
